"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filters = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const utils_1 = require("../../molecules/utils");
const toggle_1 = require("../../atoms/toggle");
const form_1 = require("../../atoms/form");
const buttons_1 = require("../../atoms/buttons");
const react_i18next_1 = require("react-i18next");
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const hasFiltersAnyValue = (props, selectValue) => {
    let hasAnyCheckboxValue = false;
    Object.values(props.checkboxesValues).forEach((value) => {
        if (value) {
            hasAnyCheckboxValue = true;
            return;
        }
    });
    return !!(selectValue ||
        props.startDate ||
        props.endDate ||
        hasAnyCheckboxValue);
};
const Filters = (props) => {
    const [selectValue, changeSelectValue] = (0, react_1.useState)("");
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        props.endDate && changeSelectValue("");
    }, [props.endDate]);
    const setStartDate = (e) => props.onSetStartDate(e.target.value);
    const setEndDate = (e) => props.onSetEndDate(e.target.value);
    const onChangeSelect = (e) => {
        changeSelectValue(e.target.value);
        props.onSetStartDate(e.target.value, true);
    };
    const onResetSelect = () => {
        changeSelectValue("");
        props.onSetStartDate("");
    };
    const onResetStartDate = () => {
        changeSelectValue("");
        props.onSetStartDate("");
    };
    const onResetEndDate = () => {
        props.onSetEndDate("");
    };
    const onCheckboxChange = (value) => () => {
        props.onCheckboxChange(value);
    };
    const onResetFilters = () => {
        changeSelectValue("");
        props.onResetFilters();
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("ratings.filterBar.filters") }, void 0), (0, jsx_runtime_1.jsx)(form_1.Select, { multiple: false, options: props.selectOptions, value: selectValue, onChange: onChangeSelect, disabled: props.disabled, onReset: onResetSelect }, void 0), (0, jsx_runtime_1.jsxs)(DateInputGroup, { children: [(0, jsx_runtime_1.jsx)(form_1.Input, { type: "date", value: props.startDate, onChange: setStartDate, disabled: props.disabled, onReset: onResetStartDate, placeholder: props.dateFormat }, void 0), (0, jsx_runtime_1.jsx)("label", { children: t("ratings.filterBar.to") }, void 0), (0, jsx_runtime_1.jsx)(form_1.Input, { type: "date", value: props.endDate, onChange: setEndDate, disabled: props.disabled, onReset: onResetEndDate, placeholder: props.dateFormat }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", { className: "error", children: props.error && (0, jsx_runtime_1.jsx)(typography_1.H4, { children: props.error }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: [1, 2, 3, 4, 5].map((value) => {
                    return ((0, jsx_runtime_1.jsx)(toggle_1.Checkbox, { checked: props.checkboxesValues[value], label: (0, jsx_runtime_1.jsx)(utils_1.RatingStars, { rate: value }, void 0), onChange: onCheckboxChange(value) }, value));
                }) }, void 0), hasFiltersAnyValue(props, selectValue) && ((0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "transparent", onClick: onResetFilters, children: t("ratings.resetFilters") }, void 0))] }, void 0));
};
exports.Filters = Filters;
const Wrapper = styled_components_1.default.div `
  height: 100%;
  margin-top: ${({ theme }) => theme.spacings.xl};

  & > h4 {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  & > div:first-of-type select {
    padding-left: ${({ theme }) => theme.spacings.xs};
  }

  & > div:nth-of-type(4) > div {
    margin: ${({ theme }) => `0 0 ${theme.spacings.xs}`};

    & h4 {
      padding-bottom: 0;
      padding-top: 0;
    }
  }

  & > button {
    bottom: 1rem;
    display: inline-block;
    font-size: 0.875rem;
    font-weight: 500;
    padding: 0;
    position: absolute;
    width: unset;
  }

  .error h4 {
    color: ${({ theme }) => theme.colors.pinkBase};
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  h4 + div div > svg {
    color: ${({ theme }) => theme.colors.greyBase} !important;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    height: unset;
    margin-top: ${({ theme }) => theme.spacings.m};
    padding: ${({ theme }) => `0 ${theme.spacings.m} 0`};

    & > h4 {
      display: none;
    }

    & > div:nth-of-type(4) > div label > div:first-of-type {
      background-color: ${({ theme }) => theme.colors.whiteBase};
    }

    & > button {
      font-size: ${({ theme }) => theme.spacings.m};
      margin-top: ${({ theme }) => theme.spacings.xs};
      position: static;
    }
  }
`;
const DateInputGroup = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: ${({ theme }) => `${theme.spacings.m} 0`};

  & > div {
    width: 141px;
    border: ${({ theme }) => isSafari ? `1px solid ${theme.colors.silverBase}` : "none"};
    ${({ theme }) => isSafari ? `border-radius: ${theme.utils.radius}` : ""};

    & > input {
      ${isSafari ? `border: none !important;` : ""};
      ${isSafari ? ` width: unset;` : ""};
      padding: ${({ theme }) => theme.spacings.xs} !important;

      &::placeholder {
        color: ${({ theme }) => theme.colors.greyLighten70};
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    width: 100%;
    margin: ${({ theme }) => `${theme.spacings.xs} 0 ${theme.spacings.xs}`};

    label {
      display: none;
    }

    & > div {
      flex: 1;
    }

    input::-webkit-calendar-picker-indicator {
      padding: 0;
      margin: 0;
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:first-of-type {
      margin-right: ${({ theme }) => theme.spacings.xs};
    }
  }
`;
//# sourceMappingURL=Filters.js.map